import jQueryBridget from 'jquery-bridget';
import Masonry from "masonry-layout";
import imagesLoaded from 'imagesloaded';

$(document).ready(function () {
  $(".hamburger").click(function () {
    $(this).toggleClass("is-active");
    $(".mobile-navigation").toggleClass("is-active");
  });
});

let url = "<?php echo get_template_directory_uri(); ?>";

$(document).ready(function () {
  $(".carousel-slider").owlCarousel({
    center: true,
    loop: true,
    nav: true,
    margin: 20,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1,
      },
      1040: {
        items: 3,
      },
    },
  });
});

$(document).ready(function () {
  $(".news-slider").owlCarousel({
    // center: true,
    
    loop: true,
    nav: true,
    margin: 16,
    stagePadding: 10,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1,
        autoHeight: true
      },
      1040: {
        items: 3,
        autoHeight: false
      },
    },
  });
});

$(document).ready(function () {
  // make Masonry a jQuery plugin
  jQueryBridget( 'masonry', Masonry, $ );
  var $grid = $('.masonry').masonry({
    itemSelector: ".masonry-item",
    fitWidth: true,
    gutter: 16,
  });
  // layout Masonry after each image loads
  $grid.imagesLoaded().progress(function () {
    $grid.masonry('layout');
  });
});
